<template>
    <v-row align="center" justify="center">
        <v-col cols="12" md="8">
            <v-card raised class="mx-auto" max-width="720px">
                <v-card-title class="pa__title">Online Residence Application Approval</v-card-title>
                <v-card-subtitle class="pt-3">
                    <v-img class="mx-auto" src="../../../assets/backgrounds/kings_logo.jpg" width="200px"></v-img>
                </v-card-subtitle>
                <!-- Approved -->
                <div v-if="status == 'approved'">
                    <v-alert class="text-center" :color="successColor" text prominent>
                        <h3>
                            <v-icon :color="successColor">mdi-check-circle</v-icon> Thank you for your approval!
                        </h3>
                        <v-divider class="my-4 success__color"></v-divider>
                        If you have any questions or concerns about the parent approval process, please contact the
                        <b>King's
                            Residence Office</b> by e-mail at <a href="mailto:residence@kings.uwo.ca">residence@kings.uwo.ca</a> or by
                        telephone at
                        <b>1-800-265-4406 x4700</b>.
                    </v-alert>
                </div>
                <!-- Processed -->
                <div v-else-if="status == 'processed'">
                    <v-alert class="text-center" :color="infoColor" text prominent>
                        <h3>
                            <v-icon :color="infoColor">mdi-bell-circle</v-icon> Parent Approval has already been
                            processed.
                        </h3>
                        <v-divider class="my-4 info__color"></v-divider>
                        If you have any questions or concerns about the parent approval process, please contact the
                        <b>King's
                            Residence Office</b> by e-mail at <a href="mailto:residence@kings.uwo.ca">residence@kings.uwo.ca</a> or by
                        telephone at
                        <b>1-800-265-4406 x4700</b>.
                    </v-alert>
                </div>
                <!-- Invalid -->
                <div v-else-if="status == 'invalid'">
                    <v-alert class="text-center" :color="warningColor" text prominent>
                        <h3>
                            <v-icon :color="warningColor">mdi-information</v-icon> The parent approval code could not be
                            processed. Either the code is invalid or does not exist.
                        </h3>
                        <v-divider class="my-4 warning__color"></v-divider>
                        Please contact the
                        <b>King's
                            Residence Office</b> by e-mail at <a href="mailto:residence@kings.uwo.ca">residence@kings.uwo.ca</a> or by
                        telephone at
                        <b>1-800-265-4406 x4700</b>.
                    </v-alert>
                </div>
                <!-- Error -->
                <div v-else-if="status == 'error'">
                    <v-alert class="text-center" :color="dangerColor" text prominent>
                        <h3>
                            <v-icon :color="dangerColor">mdi-close</v-icon> An error occurred during the parent
                            approval process.
                        </h3>
                        <v-divider class="my-4 danger__color"></v-divider>
                        Please contact the
                        <b>King's
                            Residence Office</b> by e-mail at <a href="mailto:residence@kings.uwo.ca">residence@kings.uwo.ca</a> or by
                        telephone at
                        <b>1-800-265-4406 x4700</b>.
                    </v-alert>
                </div>
                <!-- Submit code -->
                <div v-else>
                    <v-card-subtitle class="text-center">Please enter a valid code provided with the applicant's
                        Online
                        Residence Application submission.</v-card-subtitle>
                    <v-card-text>
                        <v-form ref="parentApprovalForm" v-model="valid" lazy-validation>
                            <v-text-field v-model="code" :color="kingsGreen" clearable label="Approval Code"
                                placeholder="Enter a parent approval code..." prepend-icon="mdi-account-key"
                                :rules="codeRules">
                            </v-text-field>
                        </v-form>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn ref="submitBtn" class="white--text" :disabled="!valid" :loading="submit"
                            :color="kingsGreen" @click="submitApproval()">
                            Submit
                        </v-btn>
                    </v-card-actions>
                </div>
            </v-card>
        </v-col>
    </v-row>
</template>

<script>
export default {
    name: 'parent-approval-main',
    props: {
        id: {
            required: true
        },
        status: {
            required: true
        },
        submit: {
            required: true
        }
    },
    data() {
        return {
            code: '',
            codeRules: [
                v => !!v || 'Code is required'
            ],
            valid: true
        }
    },
    methods: {
        submitApproval() {
            if (this.$refs.parentApprovalForm.validate()) {
                this.$emit('submitApproval', this.code);
            }
        }
    },
    computed: {
        dangerColor() {
            return '#f64e60';
        },
        infoColor() {
            return '#5578eb';
        },
        kingsGreen() {
            return '#004236';
        },
        successColor() {
            return '#1bc5bd';
        },
        warningColor() {
            return '#ffa800'
        }
    }
}
</script>

<style scoped>
.danger__color {
    background-color: #f64e60 !important;
    border-color: #f64e60 !important;
}

.info__color {
    background-color: #5578eb !important;
    border-color: #5578eb !important;
}

.pa__title {
    display: block !important;
    text-align: center !important;
    word-break: normal;
}

.success__color {
    background-color: #1dc9b7 !important;
    border-color: #1dc9b7 !important;
}

.warning__color {
    background-color: #ffb822 !important;
    border-color: #ffb822 !important;
}
</style>